import {css, StyleSheet} from 'aphrodite';
import React, {ReactNode} from 'react';

import {assert} from 'Asserts';
import {StudyPhase} from 'graphql-client/__generated/graphqlGlobalTypes';
import {getProceedTextForStudyPhase} from 'studies/StudyPhaseUtils';
import {ButtonStyle} from 'ui-library/buttons/Button';
import Modal from 'ui-library/modals/Modal';

interface PhaseChangeModalProps {
  currentStudyPhase: StudyPhase;
  nextStudyPhase: StudyPhase;
  phaseMessage: ReactNode | null;
  onRequestSubmit: (result: {}) => void;
  onRequestClose: () => void;
}

export default function PhaseChangeModal({
  currentStudyPhase,
  nextStudyPhase,
  phaseMessage,
  onRequestSubmit,
  onRequestClose,
}: PhaseChangeModalProps): JSX.Element {
  const getProceedText = (currentPhase: StudyPhase, nextStudyPhase: StudyPhase): string | undefined => {
    assert(currentPhase !== nextStudyPhase, 'Cannot proceed to the same phase');
    return currentPhase === StudyPhase.COMPLETE ? 'Return' : 'Proceed';
  };

  return (
    <Modal
      title={`${getProceedTextForStudyPhase(nextStudyPhase)}?`}
      buttons={[
        {
          text: 'Cancel',
          submit: false,
          style: ButtonStyle.TERTIARY_GRAY,
          onClick: () => {
            onRequestClose();
          },
        },
        {
          text: getProceedText(currentStudyPhase, nextStudyPhase),
          submit: true,
          style: ButtonStyle.PRIMARY,
        },
      ]}
      onRequestSubmit={() => {
        onRequestSubmit({});
      }}
      onRequestClose={onRequestClose}
    >
      <p className={css(styles.modalBody)}>{phaseMessage}</p>
    </Modal>
  );
}

const styles = StyleSheet.create({
  modalBody: {
    fontSize: '14px',
  },
});
